<template>
  <div>
    <div class="page">
      <div class="content-box">
        <city-select :cate-id="cateId" :search-stop="true" @searchKey="search($event)"></city-select>
        <div class="body-box">
          <van-notice-bar v-if="notice" left-icon="volume-o" mode="closeable" scrollable>
            {{ notice }}
          </van-notice-bar>
          <ads-images :ad-id="cateInfo.adsId"></ads-images>

          <van-row style="margin: 16px 0;">
            <van-col span="12">
              <div style="font-size: 18px;color: #333333;font-weight: bold;padding-top: 10px;padding-left: 10px ; ">
                优选机构
              </div>
            </van-col>
            <van-col span="12">
              <div style="font-size: 14px;color: #999999;padding-top: 10px; text-align: right;padding-right: 10px ;"
                @click="$router.push({ path: 'health-list' })">
                更多 >
              </div>
            </van-col>
          </van-row>

          <div class="box5 mt10">
            <van-swipe class="my-swipe" @change="onChange($event)">
              <van-swipe-item v-for="page in topList.pages" :key="page">
                <van-grid :column-num="4" :gutter="4">
                  <van-grid-item v-for="item in topList.records" :key="item.brandShopId"
                    :to="{ path: 'health-detail', query: { id: item.brandShopId } }">
                    <van-image :src="item.logo" height="36" round width="36"></van-image>
                  </van-grid-item>
                </van-grid>
              </van-swipe-item>
            </van-swipe>
          </div>

          <van-row>
            <van-col span="12">
              <div style="font-size: 18px;color: #333333;font-weight:bold;padding-top: 10px;padding-left: 10px ; ">
                体检预约
              </div>
            </van-col>
            <van-col span="12">
              <div
                style="font-size: 14px;color: #999999;padding-top: 10px; text-align: right;padding-right: 10px ;font-weight: 500;"
                @click="$router.push({ path: 'health-list' })">
                更多 >
              </div>
            </van-col>
          </van-row>

          <div v-cloak class="mt10">
            <van-list ref="hospListRef" v-model="loading" :error.sync="error" :finished="finished"
              :finished-text="finishedText" :immediate-check="false" :offset="100" error-text="请求失败，点击重新加载 D"
              @load="getHospitalsList">
              <div v-for="item in hospitalList" :key="item.brandShopId"
                style="margin: 16px;background-color: #FFFFFF;border-radius: 8px;">
                <van-row>
                  <van-col span="6">
                    <van-image :src="item.logo" style="width: 64px;margin-left: 4px;margin-top: 8px;"
                      @click="$router.push({ path: 'health-detail', query: { id: item.brandShopId } })"></van-image>
                  </van-col>
                  <van-col span="18" style="padding: 16px 0;"
                    @click="$router.push({ path: 'health-detail', query: { id: item.brandShopId } })">
                    <van-row>
                      <van-col span="24">{{ item.name }}</van-col>
                    </van-row>
                    <van-row class="van-hairline--bottom">
                      <van-col span="24" style="color: #999999;font-size:12px;">
                        <van-row>
                          <van-col span="18"> {{ item.address }}</van-col>

                          <!-- 距离信息 -->
                          <van-col v-if="localResult" span="6" style="text-align: right;padding: 2px 4px;">
                            {{ item.distance }} KM
                          </van-col>
                        </van-row>
                      </van-col>
                    </van-row>

                    <van-row style="margin-top: 16px;">
                      <van-col span="24">
                        <div class="van-hairline--bottom" style="margin-top: 16px;"></div>
                      </van-col>
                    </van-row>

                    <van-row style="margin-top: 16px;font-size: 14px;">
                      <div v-for="goodsItem in item.goodsList" :key="goodsItem.name"
                        style="height: 30px;line-height: 30px;display: flex">
                        <img alt="" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
                          style="width: 16px;height: 16px;display: inline-block;line-height: 30px;margin-top: 6px;" />
                        <span
                          style="color: #f00;font-weight: 600;width: 80px;display: inline-block;height: 30px;line-height: 30px;">
                          {{ parseFloat((goodsItem.price / 100).toString()).toFixed(2) }}
                        </span>
                        <span class="van-ellipsis"
                          style="color: #666666;font-weight: 500;width: 140px;display:inline-block;height: 30px;line-height: 30px;">
                          {{ goodsItem.name }}
                        </span>
                        <span style="color: #666666;">></span>
                      </div>
                    </van-row>
                  </van-col>
                </van-row>
              </div>

            </van-list>
          </div>

        </div>
      </div>
    </div>

    <PageFooter :active="0"></PageFooter>
  </div>
</template>

<script>
import { Dialog } from "vant";
import GoodsListBlock from "@/components/common/GoodsListBlock";
import AdsImages from "@/components/common/ads-images";
import CitySelect from "@/components/common/city-select";
import MallSortTable from "@/components/common/MallSortTable";
import { GOODS_CATE_INFO, GOODS_TAGS, MallModules } from "@/api/constant";
import { api_get_hospital_list, api_get_hospital_top_list } from "@/api/goods-api";
import TabBarBook from "@/components/common/tabbar-books";
import PageFooter from "@/components/common/page-footer";
import { wx_get_jsapi_ticket, toChannelIndex } from "@/api/user";
import { get_user_poi_location } from "@/util/wxSdk";
import { getSysConfigValue } from "@/api/sys-api";

export default {
  name: "health-index",

  components: { PageFooter, TabBarBook, GoodsListBlock, AdsImages, CitySelect, MallSortTable },

  data() {
    return {
      tabActive: 0,
      cateList: [],
      goodsList: [],
      cateInfo: GOODS_CATE_INFO.health,
      recommendTag: GOODS_TAGS.recommend,
      cateId: GOODS_CATE_INFO.health.id,
      topList: [],
      error: false,
      loading: false,
      finished: false,
      finishedText: "没有更多了 H",
      hospitalList: [],
      pi: 0,
      searchKey: '',
      notice: '',
      localResult: false
    }
  },

  computed: {
    poi: function () {
      return sessionStorage.getItem("USER_CURRENT_POI_LAT");
    }
  },

  created() {
    toChannelIndex(this.cateId).then(res => {
      if (res.code === 0) {
        this.$store.dispatch('store_get_user_info')

        const module = MallModules.find((mall) => mall.topCateId === 8);
        this.$store.commit("SET_MALL_MODULE", module);

        wx_get_jsapi_ticket(encodeURIComponent(window.location.href)).then(res => {
          budo_log.info("#175 wx_get_jsapi_ticket", res)

          if (res.code === 0) {
            get_user_poi_location(res, (result) => {
              this.localResult = result;
              this.hospitalList = [];
              this.pi = 0;
              this.getHospitalsList();
            })
          }
        }
        )

        getSysConfigValue('Health_Index_Notice').then(res => {
          this.notice = res.data;
        })

        api_get_hospital_top_list(1, 8, true).then(res => {
          this.topList = res.data;
        })

        window.onscroll = this.doScroll;
        this.cateId = 8;

        for (const cate in GOODS_CATE_INFO) {
          if (GOODS_CATE_INFO[cate].id === this.cateId) {
            this.cateInfo = GOODS_CATE_INFO[cate];
            budo_log.info('#223 cateInfo', this.cateInfo)
          }
        }
      } else {
        budo_log.info("#223 go bind card")

        Dialog.confirm({ message: "跳转绑卡?" }).then(() => {
          this.$router.push({ path: '/bind-card' });
        })
      }
    })
  },

  methods: {
    search(keyVal) {
      this.$router.push({ path: 'health-list', query: { 'searchKey': keyVal } });
    },

    getHospitalsList() {
      budo_log.info("#215 getHospitalsList health index")

      this.finishedText = "加载中 A ...";
      this.pi++;

      api_get_hospital_list(this.pi, 10, this.searchKey).then(res => {
        this.hospitalList = this.hospitalList.concat(
          res.data.records
        );

        budo_log.info('#231 api_get_hospital_list', res.data)
        if (this.hospitalList.length >= res.data.total) {
          this.finishedText = "没有更多了 I";
          this.finished = true;
        }

        if (res.data.total === 0) {
          this.finishedText = "看看其它的吧 B";
          this.finished = true;
        }

        this.loading = false;
      }).catch((error) => {
        budo_log.info('#260', error)
        this.loading = false;
        this.error = true;
      });
    },

    onChange(index) {
      budo_log.info('#266 onChange', index)

      api_get_hospital_top_list(index + 1, 8, true).then(res => {
        this.topList = res.data;
      })
    },

    doScroll() {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // 获取页面滚动距离之后设置给当前路由的元信息
        this.$route.meta.y = window.pageYOffset;
        budo_log.info('#267 doScroll pageYOffset', window.pageYOffset)
      }, 300);
    },
    toDetail(cateId, topicId) {
      if (topicId > 0) {
        this.$router.replace({ path: 'topic-detail', query: { topicId: topicId, buyFlag: '1' } })
        return
      }

      this.$router.replace({ path: 'cate-index', query: { cateId: cateId } })
    }
  },
  // 处理ios url兼容
  beforeRouteEnter(to, from, next) {
    if (('/web' + to.path) !== location.pathname || ('/web' + to.path) !== '/web' + to.fullPath) {
      location.assign('/web' + to.fullPath.split('?')[0])
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .van-grid-item__content {
    padding: 4px;
  }
}

.page {
  background-color: #EDF0F5;
  padding-bottom: 120px;
  min-height: 100vh;

  .content-box {
    .box1 {
      padding: 0 11px;
      background-color: white;

      ::v-deep {
        .van-dropdown-menu__bar {
          box-shadow: unset;
        }
      }
    }

    .body-box {
      padding: 10px 0;

      .box2 {
        padding: 0 15px;

        .my-swipe {
          border-radius: 5px;

          .van-swipe-item {
            color: #fff;
            font-size: 20px;
            line-height: 150px;
            text-align: center;
            background-color: #39a9ed;
          }
        }
      }

      .box3 {
        padding: 0 15px;
        color: #9A9A9A;
        font-size: 12px;
        margin: 14px 0;
      }

      .box4 {
        // height: 100px;
        background: #FFFFFF;
        border-radius: 5px;
        padding: 10px;
        font-size: 12px;
        color: #333333;
      }

      .box5 {


        //  background: #FFFFFF;
        border-radius: 8px;
        margin: 10px 15px;
      }

      .box7 {
        background: #FFFFFF;
        border-radius: 8px;
        margin: 10px 15px;
      }

      .box6 {
        padding: 0;

        .goods-box {
          margin-top: 10px;

          .goods-item {
            width: 133px;
            height: 261px;
            background: #FFFFFF;
            border-radius: 4px;
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>
